import React, { useCallback } from 'react';
import GridOnIcon from 'mdi-react/GridOnIcon';
import GridOffIcon from 'mdi-react/GridOffIcon';
import { useDispatch, useSelector } from 'react-redux';

import { Button } from '@crm-framework/button';

import { IStateWithGridLayout } from './models';
import { getIsEditModeOn, gridLayoutActions } from './store';

type EditLayoutButtonParams = {
  storageName: string;
};

export const EditLayoutButton: React.FC<EditLayoutButtonParams> = ({
  storageName,
}) => {
  const dispatch = useDispatch();
  const isEditModeOn = useSelector((state: IStateWithGridLayout) =>
    getIsEditModeOn(state, storageName)
  );

  const onChangeEditMode = useCallback(() => {
    dispatch(
      gridLayoutActions.setIsEditModeOn({
        name: storageName,
        value: !isEditModeOn,
      })
    );
  }, [isEditModeOn]);

  return (
    <Button
      prefix={
        isEditModeOn ? (
          <GridOnIcon size="1.3em" />
        ) : (
          <GridOffIcon size="1.3em" />
        )
      }
      baseAppearance="compact"
      appearance="primary"
      title={isEditModeOn ? 'Editing On' : 'Editing Off'}
      onClick={onChangeEditMode}>
      Edit Layout
    </Button>
  );
};

export const ResetLayoutButton: React.FC<EditLayoutButtonParams> = ({
  storageName,
}) => {
  const dispatch = useDispatch();

  const onResetPanels = useCallback(() => {
    dispatch(
      gridLayoutActions.resetPanels({
        name: storageName,
        value: true,
      })
    );
  }, []);

  return (
    <Button
      baseAppearance="compact"
      appearance="primary"
      onClick={onResetPanels}>
      Reset panels
    </Button>
  );
};
